import { render, staticRenderFns } from "./SectionsNav.vue?vue&type=template&id=117861e2&scoped=true&"
import script from "./SectionsNav.vue?vue&type=script&lang=js&"
export * from "./SectionsNav.vue?vue&type=script&lang=js&"
import style0 from "./SectionsNav.vue?vue&type=style&index=0&id=117861e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117861e2",
  null
  
)

export default component.exports